import { ApiForAiSettingsService } from '@api'
import { attach, createEffect } from 'effector'

import { $creatorId } from '@/models/creators.ts'
import { toast } from '@/models/toasts.ts'
import { handleError } from '@/utils/error'

export const setTypoFrequencyFx = attach({
  name: 'set Typo Frequency',
  source: {
    creatorId: $creatorId,
  },
  mapParams: (typoFrequency: number, { creatorId }) => ({
    creatorId: creatorId!,
    requestBody: { typoFrequency },
  }),
  effect: createEffect(ApiForAiSettingsService.setTypoFrequency),
})

setTypoFrequencyFx.doneData.watch(() => {
  toast.success('Typo percentage set successfully')
})

setTypoFrequencyFx.failData.watch((error) =>
  handleError(error, 'Failed to set typo frequency'),
)
